// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"initial-view_wrapper__2C0Ad"};